import http from '@/core/http';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import {
  IAppInfoParams,
  IAppInfoItem,
  IAppManageInfoCreateReq,
  IAppManageInfoUpdateEnableReq,
  IAppManageInfoLog,
  IAppManageInfoListReq,
  IAppManageInfoItem,
} from './index.d';
/**
 * @see https://yapi.ibaibu.com/project/996/interface/api/107056
 *
 */
export const getAppInfoPage = (params: IAppInfoParams) => {
  return http.post<IAppInfoItem[]>({
    url: '/manage-app/web/v1/app-manage-info/page',
    data: params,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 启用/停用
export const UpdateEnableAppInfo = (params: IAppManageInfoUpdateEnableReq) => {
  return http.put({
    url: '/manage-app/web/v1/app-manage-info/updateEnable',
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 删除
export const DelAppInfo = (id: string) => {
  return http.delete({
    url: `/manage-app/web/v1/app-manage-info/del/${id}`,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 添加
export const AddAppInfo = (params: IAppManageInfoCreateReq) => {
  return http.post({
    url: '/manage-app/web/v1/app-manage-info/save',
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 编辑
export const EditAppInfo = (params: IAppManageInfoCreateReq) => {
  return http.post({
    url: '/manage-app/web/v1/app-manage-info/update',
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 操作记录
export const AppInfoLogs = (id: string) => {
  return http.get<IAppManageInfoLog[]>({
    url: `/manage-app/web/v1/manage-ope-log/list/${id}`,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};

export const getAppList = (params: IAppManageInfoListReq) => {
  return http.post<IAppManageInfoItem[]>({
    url: '/manage-app/web/v1/app-manage-info/list',
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
  // return Promise.resolve({
  //   code: '200',
  //   data: [
  //     { name: '找布易 APP', code: 'SELLER_APP', updateType: 'UpdateOutside' },
  //     { name: '八爪鱼 APP', code: 'octopus_app', updateType: 'UpdateBzy' },
  //     { name: '致衣 APP', code: 'zhicloth_app', updateType: 'UpdateZy' },
  //     { name: '天工 APP', code: 'tiangong_app', updateType: 'UpdateBzy' },
  //   ],
  //   message: '请求成功',
  //   successful: true,
  // });
};
